import React from 'react';
import { useController } from 'react-hook-form';
import {
  IncidentCategoryChooser,
  type IncidentCategoryChooserProps,
} from './IncidentCategoryChooser';

interface Props extends Omit<IncidentCategoryChooserProps, 'onChange' | 'value'> {
  name: string;
}

export const HookedIncidentCategoryChooser = (props: Props) => {
  const { name, ...rest } = props;
  const { field } = useController({ name });

  return <IncidentCategoryChooser {...rest} value={field.value} onChange={field.onChange} />;
};
